module.exports = __webpack_public_path__ + "img/jiancegongcheng.0093f643.jpg";